<template>
  <div>
    <!-- Page Header -->
    <div class="mb-5">
      <div class="headline saPrimary--text">
        {{ $t("admin.page.film.title") }}
      </div>
      <span class="body-1 greyDarken3--text">{{
        $t("admin.page.film.list.subtitle")
      }}</span>
    </div>

    <!-- Filters -->
    <v-card class="mb-3">
      <v-card-text>
        <v-layout row wrap>
          <v-flex xs12 sm12 md6>
            <!-- Schedule Type -->
            <v-autocomplete
              v-model="selected_company"
              :items="companies.data"
              :label="$t('admin.page.film.filter.select_company')"
              item-text="title"
              item-value="id"
              hide-details
              color="saSecondary"
              @input="getFilmsFromApi()"
            ></v-autocomplete>
          </v-flex>
          <!-- <v-divider vertical class="mx-3"></v-divider> -->
          <v-flex xs12 sm12 md4>
            <!-- Screening Type -->
            <!-- <v-select
              v-model="event_type"
              :items="DEFINES.SCREENER_TYPES"
              :label="'Event Type'"
              item-text="text"
              item-value="value"
              hide-details
              color="saSecondary"
              @input="getFilmsFromApi()"
            ></v-select> -->
          </v-flex>
          <!-- <v-divider vertical class="mx-3"></v-divider> -->

        </v-layout>
      </v-card-text>
    </v-card>
  <!-- Page Content -->
    <v-card>
      <v-card-title>
        <div v-if="films.length" class="title">
          <span>Total Storage : </span>
          <b>{{totalConsumedStorage}} MB</b> <span class="pl-2">({{MBtoGB(totalConsumedStorage)}}) GB</span>
        </div>
        <v-spacer></v-spacer>
      </v-card-title>
      <v-data-table
        :headers="table_headers"
        :loading="loading"
        :items="films"
        :pagination.sync="pagination"
        :total-items="total"
        :rowsPerPageItems="rowsPerPageItems"
        item-key="id"
      >
        <template v-slot:items="props">
          <tr class="cursor-pointer" @click="viewProfile(props.item.id)">
            <td width="5%">{{ props.item.id }}</td>
            <td>
              <v-img
                width="50"
                height="50"
                v-if="props.item.thumburls"
                :src="props.item.thumburls"
              ></v-img>
            </td>
            <td class="py-1">{{ props.item.title }}</td>
            <td>{{props.item.assignedScreeners | VirtualEvents | countItems}}</td>
            <td>{{props.item.assignedScreeners | EventType(DEFINES.EVENT_TYPE.VOD_EVENTS) | countItems}}</td>
            <td>{{props.item.assignedScreeners | PhysicalEvents | countItems}}</td>
            <td>{{props.item.assignedScreeners | VirtualAndPhysical | countItems}}</td>
            <td>{{bytesToMB(props.item.consumedStorage)}} MB</td>
            <td>{{props.item.created_at}}</td>
          </tr>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import { mapState } from "vuex";
import i18n from "@/i18n";
import Avatar from "vue-avatar";

export default {
  name: "AdminFilmList",
  components: {
    Avatar
  },
  data() {
    return {
      search: "",
      list: null,
      companies: [],
      selected_company: null,
      event_type: null,
      loading: false,
      table_headers: [
         {
          text: i18n.t("admin.films.page.table.header.id"),
          align: "left",
          sortable: false
        },
        {
          text: i18n.t("rms.table.header.thumbnail"),
          align: "left",
          sortable: false
        },
        {
          text: i18n.t("rms.table.header.title"),
          align: "left",
          sortable: true,
          value: "title"
        },
        {
          text: i18n.t("admin.films.page.table.header.virtual"),
          align: "left",
          sortable: true,
          value: "title"
        },
        {
          text: i18n.t("admin.films.page.table.header.vod"),
          align: "left",
          sortable: true,
          value: "title"
        },
        {
          text: i18n.t("admin.films.page.table.header.physical"),
          align: "left",
          sortable: true,
          value: "title"
        },
        {
          text: i18n.t("admin.films.page.table.header.physical_and_virtual"),
          align: "left",
          sortable: true,
          value: "title"
        },
        {
          text: i18n.t("admin.films.page.table.header.consumed_storage"),
          align: "left",
          sortable: true,
          value: "title"
        },
        { text: i18n.t("rms.table.header.created_on"), sortable: false }
      ],
      rowsPerPageItems: [5, 10, 25, 50, 100],
      pagination: {
        sortBy: "created_at",
        descending: true,
        page: 1,
        rowsPerPage: 10,
      },
      total: null,
      films: []
    };
  },
  filters: {
    countItems: function (items) {
      return items.length
    }
  },
  mounted() {
    this.getCompaniesFromApi();
  },
  computed: {
    vodEvents() {
      if(!this.films.length){
        return null
      }
    },

    totalConsumedStorage() {
     let  total_size_in_bytes = this.films.map(film => film.consumedStorage).reduce((prev, curr) => parseInt(prev) + parseInt(curr), 0);
     let size_in_mb = total_size_in_bytes/(1024*1024);
     return parseFloat(size_in_mb).toFixed(2);
    },

  },

  methods: {
    async getFilms() {
      // var response = await this.$store.dispatch("adminFilm/list");
      // this.list = response.films;
    },

    async getCompaniesFromApi() {
      this.loading = true;
      try {
        let response = await this.$store.dispatch("adminCompany/list");
        this.companies = response.companies;
      } catch (error) {
        this.$store.dispatch("app/showMessage", {
          message: error.message,
          color: this.DEFINES.SNACKBAR_ERROR_COLOR,
        });
      }

      this.loading = false;
    },

    async getFilmsFromApi() {
      await this.$store.dispatch('adminFilm/getFilmListByCompany',{
        company_id: this.selected_company,
        event_type: this.event_type
      })
      .then((response) => {
        this.films = response.films
      })
      .catch((error) => {
        console.error(error)
      })
    },

    bytesToMB(bytes){
      let size_in_mb = bytes/(1024*1024);
      return parseFloat(size_in_mb).toFixed(2);
    },
    MBtoGB(mb){
      let size_in_gb = mb/(1024);
      return parseFloat(size_in_gb).toFixed(2);
    }
  }
};
</script>

